import { InfoBlock, useTranslator } from "@sia/style-guide";
import { useContext } from "react";
import { WizarContext } from "contexts/WizardContext";

const Summary = () => {
  const translate = useTranslator();
  const { state } = useContext(WizarContext);
  let personalInfo = state.student.personalInfo;
  // let workplaceInfo = state.single.workplaceInfo;
  // let otherAddressesInfo = state.single.otherAddressesInfo;
  // let educationInfo = state.single.educationInfo;
  let sectionInfo = state.student.sectionInfo;
  let communicationInfo = state.student.communicationInfo;

  let newsletters = {
    newsLetterGerman: translate("wizard.form.single.communication.newsletter.german.label"),
    newsLetterFrench: translate("wizard.form.single.communication.newsletter.french.label"),
    siaInformNewsletterDe: translate("wizard.form.single.communication.inform-newsletter.german.label"),
    siaInformNewsletterFr: translate("wizard.form.single.communication.inform-newsletter.french.label"),
    siaInformNewsletterIt: translate("wizard.form.single.communication.inform-newsletter.italian.label"),
  };

  let selectedNewsletter = Object.keys(newsletters).filter((key) => communicationInfo[key]);

  return (
    <div className="summary-info-page">
      <InfoBlock>
        <span className="label">{translate("wizard.form.single.personal-info.gender.label")}</span>
        <p>{personalInfo.gender}</p>
        <span className="label">{translate("wizard.form.single.personal-info.first-name.label")}</span>
        <p>{personalInfo.firstName}</p>
        <span className="label">{translate("wizard.form.single.personal-info.last-name.label")}</span>
        <p>{personalInfo.lastName}</p>
        <span className="label">{translate("wizard.form.single.personal-info.nationality.label")}</span>
        <p>{personalInfo.nationality}</p>
        <span className="label">{translate("wizard.form.single.personal-info.birth-date.label")}</span>
        <p>{personalInfo.dateOfBirth}</p>
        <span className="label">{translate("wizard.form.single.personal-info.language.label")}</span>
        <p>{personalInfo.language.label}</p>
        <span className="label">{translate("wizard.form.single.personal-info.diplom-title.label")}</span>
        <p>{personalInfo.diplomTitle}</p>
      </InfoBlock>
      <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.single.personal-info.address.title")}</p>
      <InfoBlock>
        <span className="label">{translate("wizard.form.single.personal-info.additional-info.label")}</span>
        <p>{personalInfo.additionalInfo}</p>
        <span className="label">{translate("wizard.form.single.personal-info.street.label")}</span>
        <p>{personalInfo.street}</p>
        <span className="label">{translate("wizard.form.single.personal-info.zip.label")}</span>
        <p>{personalInfo.zip}</p>
        <span className="label">{translate("wizard.form.single.personal-info.city.label")}</span>
        <p>{personalInfo.city}</p>
        <span className="label">{translate("wizard.form.single.personal-info.country.label")}</span>
        <p>{personalInfo.country.label}</p>
        <span className="label">{translate("wizard.form.single.personal-info.canton.label")}</span>
        <p>{personalInfo.canton.label}</p>
        {personalInfo.phone && (
          <>
            <span className="label">{translate("wizard.form.single.personal-info.telephone.label")}</span>
            <p>{personalInfo.phone}</p>
          </>
        )}
        {personalInfo.mobile && (
          <>
            <span className="label">{translate("wizard.form.single.personal-info.mobile.label")}</span>
            <p>{personalInfo.mobile}</p>
          </>
        )}
        {personalInfo.email && (
          <>
            <span className="label">{translate("wizard.form.single.personal-info.email.label")}</span>
            <p>{personalInfo.email}</p>
          </>
        )}
      </InfoBlock>
      <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.student.study-section.title")}</p>
      <InfoBlock>
        <span className="label">{translate("wizard.form.single.education.bachelor.school-name.label")}</span>
        <p>{personalInfo.schoolName.label}</p>
        <span className="label">{translate("wizard.form.single.education.bachelor.study-type.label")}</span>
        <p>{personalInfo.studyType.label}</p>
        <span className="label">{translate("wizard.form.single.education.bachelor.earn-date.label")}</span>
        <p>{personalInfo.studyStart}</p>
        <span className="label">{translate("wizard.form.single.education.bachelor.diplom-title.label")}</span>
        <p>{personalInfo.studyEnd}</p>
        <span className="label">{translate("wizard.form.single.summary.master.reference.label")}</span>
        <p>{personalInfo?.proofOfEnrollmentFile?.[0].file.name}</p>
      </InfoBlock>

      <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.single.summary.sections.title.label")}</p>
      <InfoBlock>
        <span className="label">{translate("wizard.form.single.summary.sections.label")}</span>
        <p>{sectionInfo.section.label}</p>
        <span className="label">{translate("wizard.form.single.summary.profession.label")}</span>
        <p>{sectionInfo.professionalGroup.label}</p>
      </InfoBlock>

      {(communicationInfo.selectedMagazine || selectedNewsletter.length > 0) && (
        <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.single.communication.magazins.label")}</p>
      )}
      {communicationInfo.selectedMagazine && (
        <InfoBlock>
          <span className="label">{translate("wizard.form.single.summary.selected.label")}</span>
          <p>{communicationInfo.selectedMagazine}</p>
          <span className="label">{translate("wizard.form.single.summary.format.label")}</span>
          {communicationInfo.magazineFormatEpaper && <p>{translate("subscriptionBox.form.e-paper")}</p>}
          {communicationInfo.magazineFormatPrinted && <p>{translate("subscriptionBox.form.printed")}</p>}
        </InfoBlock>
      )}
      {selectedNewsletter.length > 0 && (
        <InfoBlock>
          <span className="label">{translate("wizard.form.single.summary.selected.label")}</span>
          {selectedNewsletter.map((key) => (
            <p>{translate(newsletters[key])}</p>
          ))}
        </InfoBlock>
      )}
    </div>
  );
};

export default Summary;
